import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/travel/$segmentId` activates the segment-detail column
// (col 2). The Travel LAYOUT route (travel.tsx) reads `$segmentId` from the leaf
// match and renders every column via ColumnLayout. Mirrors forms/$formId.
export const Route = createFileRoute("/$orgSlug/$eventSlug/travel/$segmentId")({
  component: () => null,
})
